<template>
    <table class="table table-striped">
        <thead>
            <tr>
                <th class="th-first">
                    <input
                        type="checkbox"
                        value=""
                        @click="selectAll"
                        :checked="selectedAll"
                    />
                </th>
                <th>{{ __('document_type') }}</th>
                <th>{{ __('document_number') }}</th>
                <th>{{ __('contractor_name') }}</th>
                <th>{{ __('date_issued') }}</th>
                <th class="text-right">{{ __('amount_required') }}</th>
                <th>{{ __('currency') }}</th>
                <th class="text-right">{{ __('exchange_rate') }}</th>
                <th class="text-right">{{ __('amount_due_in_base_currency_2') +' '+  this.userInfo.default_currency.toUpperCase()}}
                </th>
                <th>{{ __('maturity_date_short') }}</th>
                <th class="text-right">{{ __('number_of_days_late_short') }}</th>
                <th class="th-before th-last"></th>
            </tr>
        </thead>

        <tbody>
            <template v-if="isSetIntervals()">
                <template
                    v-for="(interval, index) in intervalsSettings.intervals"
                >
                    <summary-row
                        :title="agingRangeTitle(interval.from, interval.to)"
                        :sum="
                            sumLiabilities({
                                from: interval.from,
                                to: interval.to
                            })
                        "
                        :sumInBase="
                            sumLiabilitiesInBase({
                                from: interval.from,
                                to: interval.to
                            })
                        "
                    />
                    <item-row
                        v-for="due in liabilitiesFilter({
                            from: interval.from,
                            to: interval.to
                        })"
                        :key="due.id"
                        :due="due"
                        :permission_access="permission_access"
                        :documentScanRoute="documentScanRoute"
                        :documentPdfRoute="documentPdfRoute"
                        :previewRoute="previewRoute"
                        :tab="tab"
                        :previewReturnRoute="previewReturnRoute"
                        @unselect="selectedAll = false"
                    />
                </template>
            </template>

            <template v-else>
                <item-row
                    v-for="due in liabilities"
                    :key="due.id"
                    :due="due"
                    :permission_access="permission_access"
                    :documentScanRoute="documentScanRoute"
                    :documentPdfRoute="documentPdfRoute"
                    :previewRoute="previewRoute"
                    :previewReturnRoute="previewReturnRoute"
                    @unselect="selectedAll = false"
                    :tab="tab"
                />
            </template>
            <summary-row
                :title="__('sum')"
                :sum="sumAmountDue()"
                :sumInBase="sumAmountDueInBase()"
            />
        </tbody>
    </table>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SummaryRow from './tr/SummaryRow'
import ItemRow from './tr/ItemRow'

export default {
    name: 'receivables-table',
    data() {
        return {
            selectedAll: false
        }
    },
    components: {
        SummaryRow,
        ItemRow,
    },
    props: {
        tab:{
            type: String,
            default: '#'
        },
        liabilities: {
            type: Array,
            default: null
        },
        documentScanRoute: {
            type: String,
            default: '#'
        },
        documentPdfRoute: {
            type: String,
            default: '#'
        },
        previewRoute: {
            type: String,
            default: '#'
        },
        previewReturnRoute: {
            type: String,
            default: '#'
        },
        permission_access: {
            default: null
        },
        helpName: {
            type: String,
            default: ''
        }
    },
    computed: {
        minInterval: function() {
            return this.intervalsSettings.intervals[0].from
        },
        maxInterval: function() {
            return this.intervalsSettings.intervals[
                this.intervalsSettings.intervals.length - 1
            ].to
        },
        ...mapGetters({
            intervalsSettings: 'getIntervalsSettings'
        }),
        userInfo: function () {
            return this.$store.getters.getUserInfo
        },
    },
    methods: {
        liabilitiesFilter(between) {
            return this.liabilities.filter(function(item) {
                return (
                    item.days_late >= between.from * 1 &&
                    item.days_late <= between.to * 1
                )
            })
        },
        amount_due_in_base_currency(amount, exchaneRate) {
            if(amount == undefined || exchaneRate == undefined){
                return 0;
            }
            if (exchaneRate == '-') {
                return amount
            } else {
                return (parseFloat(amount) * parseFloat(exchaneRate)).toFixed(2)
            }
        },
        sumLiabilities(between) {
            let filtered = this.liabilitiesFilter(between),
                sum = 0

            filtered.forEach(element => {
                sum += element.payment.payment_amount * 1
            })

            return sum.toFixed(2)
        },
        sumLiabilitiesInBase(between) {
            let filtered = this.liabilitiesFilter(between),
                sum = 0
            filtered.forEach(element => {
                sum += this.amount_due_in_base_currency(
                    element.payment.payment_amount,
                    element.document.exchange_rate == 1
                        ? '-'
                        : element.exchange_rate
                ) * 1;
            })

            return sum.toFixed(2)
        },
        agingRangeTitle(from, to) {
            return this.__('age_range_from_to_days')
                .replace('[from]', from)
                .replace('[to]', to)
        },
        sumAmountDue() {
            let sum = 0

            this.liabilities.forEach(element => {
                if (
                    (this.isSetIntervals() &&
                        this.isDateInIntervalsRange(element.days_late)) ||
                    !this.isSetIntervals()
                ) {
                    sum += element.payment.payment_amount * 1
                }
            })

            return sum.toFixed(2)
        },
        sumAmountDueInBase() {
            let sum = 0

            this.liabilities.forEach(element => {
                if (
                    (this.isSetIntervals() &&
                        this.isDateInIntervalsRange(element.days_late)) ||
                    !this.isSetIntervals()
                ) {
                    sum +=
                        this.amount_due_in_base_currency(
                            element.payment.payment_amount,
                            element.document.exchange_rate == 1
                                ? '-'
                                : element.exchange_rate
                        ) * 1
                }
            })

            return sum.toFixed(2)
        },
        selectAll() {
            this.deleteAllSelected()

            if (event.target.checked) {
                this.selectedAll = true
                let ids = this.liabilities.map(item => item.payment.id)
                this.addToSelected(ids)
            } else {
                this.selectedAll = false
            }
        },
        clearSelected() {
            this.selectedAll = false
        },
        isSetIntervals() {
            return (
                this.intervalsSettings.intervals != null &&
                this.intervalsSettings.intervals.length > 0
            )
        },
        isDateInIntervalsRange(val) {
            return val >= this.minInterval && val <= this.maxInterval
        },
        ...mapActions(['addToSelected', 'deleteAllSelected'])
    }
}
</script>

<style lang="scss" scoped></style>
